import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { ProductMaterialCategory, ProductMaterialType } from 'models';
import { ProductMaterialTypeService } from 'services';
import { ErrorService } from 'services/error-service';
import { ToastService } from 'services/toast-service';

@autoinject()
export class MooringProductMaterialTypeContainer {
  protected headers: {
    title: string;
  }[] = [];

  constructor(
    private errorService: ErrorService,
    private mooringProductTypeService: ProductMaterialTypeService,
    private toast: ToastService,
    private t: I18N
  ) {}

  protected attached() {
    this.createHeaders();
    void this.getTypes();
  }

  protected types: ProductMaterialCategory[] = [];
  protected async getTypes() {
    this.types = await this.mooringProductTypeService.getAll(`?$expand=ProductMaterialCategory`);
  }

  protected async onDelete(id: number) {
    try {
      if (id) {
        await this.mooringProductTypeService.delete(id);
        this.toast.showSuccess(this.t.tr('general.deleted'));
        await this.getTypes();
      }
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected async onSave(type: ProductMaterialType) {
    try {
      if (type.Id) {
        await this.mooringProductTypeService.put(type, type.Id);
      } else {
        await this.mooringProductTypeService.post(type);
      }
      this.toast.showSuccess(this.t.tr('general.saved'));
      await this.getTypes();
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected isCreating = false;
  protected editingType: number | undefined = undefined;
  protected setEditingType(id: number) {
    this.isCreating = false;
    this.editingType = id;
  }

  protected setIsCreatingType(isCreating: boolean) {
    this.editingType = undefined;
    this.isCreating = isCreating;
  }

  private createHeaders() {
    this.headers = [
      { title: this.t.tr('general.category') },
      { title: this.t.tr('general.name') },
      { title: this.t.tr('general.name-en') },
      { title: this.t.tr('general.name-es') },
      { title: this.t.tr('general.actions') },
    ];
  }
}
